import { z } from 'zod'

/**
 * These schemas are the single source of truth for credential shape.
 * The planner uses them for form validation; the API relies on Better Auth,
 * which enforces the same constraints server-side via its own config.
 */

export const emailSchema = z.email('Zadejte platný e-mail')

export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_LENGTH = 128

export const passwordSchema = z
  .string()
  .min(PASSWORD_MIN_LENGTH, `Použijte alespoň ${PASSWORD_MIN_LENGTH} znaků`)
  .max(PASSWORD_MAX_LENGTH, `Použijte nejvýše ${PASSWORD_MAX_LENGTH} znaků`)

export const signUpSchema = z.object({
  name: z.string().trim().min(1, 'Zadejte své jméno').max(100),
  email: emailSchema,
  password: passwordSchema,
})

export const signInSchema = z.object({
  email: emailSchema,
  password: z.string().min(1, 'Zadejte heslo'),
})

export type SignUpInput = z.infer<typeof signUpSchema>
export type SignInInput = z.infer<typeof signInSchema>
